export enum Role {
    User = 'User',
    Admin = 'Admin',
    Orbit = 'Orbit',
    AdminOrbit = 'AdminOrbit',
    SubUser = 'SubUser'
}